import { Component, Input, OnInit } from '@angular/core';
import { Message } from '../../../../classes/Message';
import { CustomerService } from '../../../../services';
import { MessageService } from 'primeng';
import { deepClone } from 'fast-json-patch';

@Component({
  selector: 'app-customer-call-stats',
  templateUrl: './customer-call-stats.component.html',
  styleUrls: ['./customer-call-stats.component.scss', '../customer-information.component.scss'],
})
export class CustomerCallStatsComponent implements OnInit {
  constructor(private customerService: CustomerService, private messageService: MessageService) {}

  private _customerId: number;
  @Input()
  get customerId(): number {
    return this._customerId;
  }

  set customerId(value: number) {
    if (this._customerId !== value) {
      this._customerId = value;
      this.loadInformation();
    }
  }

  isBusy = false;
  stats: TelephonyStatDTO[];
  filteredStats: TelephonyStatDTO[];

  dates = [];
  operators = [];
  reasons = [];

  selectedDate;
  selectedOperator;
  selectedReason;

  ngOnInit() {}

  loadInformation() {
    this.isBusy = true;

    this.customerService
      .getCallStats(this.customerId)
      .then((stats) => {
        this.stats = stats;
        this.filteredStats = stats;

        let cnt = 0;
        this.stats.forEach((x) => {
          cnt++;
          x.oddeven = cnt % 2 === 0 ? 'even' : 'odd';
        });

        this.isBusy = false;

        // use Set for unique dates in UTC (avoids boundary issues when removing time component)
        const uniqueDates = new Set(
          this.stats.map((x) => {
            const date = new Date(x.created);
            // Get the date part in UTC (yyyy-mm-dd format)
            return date.toISOString().split('T')[0];
          }),
        );

        this.dates = Array.from(uniqueDates).map((dateString) => {
          const date = new Date(dateString);
          return { label: this.formatDate(date), value: dateString }; // Value is already in yyyy-mm-dd format
        });

        this.dates.unshift({ label: 'Any Date', value: null });

        const uniqueOperators = new Set(this.stats.map((x) => x.operatorId));

        this.operators = Array.from(uniqueOperators).map((operatorId) => {
          const operator = this.stats.find((x) => x.operatorId === operatorId);
          return { label: operator?.operatorName || '', value: operatorId };
        });
        this.operators.unshift({ label: 'Any Operator', value: null });

        const uniqueReasons = new Set(this.stats.map((x) => x.disposition));

        this.reasons = Array.from(uniqueReasons).map((reason) => {
          return { label: reason || '', value: reason };
        });
        this.reasons.unshift({ label: 'Any Reason', value: null });
      })
      .catch((err) => {
        this.messageService.add(
          Message.Error(
            'Load Customer Call Stats',
            'An error occurred loading customer call stats',
          ),
        );
        this.isBusy = false;
      });
  }

  toggleAISummary(call: any) {
    call.showAISummaryStart = !call.showAISummaryStart;

    if (!call.showAISummaryStart) {
      // Remove the newly spliced in item
      let index = this.filteredStats.indexOf(call);
      this.filteredStats.splice(index + 1, 1);
    } else {
      // Find position of call in table rows
      let index = this.filteredStats.indexOf(call);

      // Splice new row into table rows
      let newRow = { summaryRow: true, oddeven: call.oddeven, showAISummaryEnd: true };

      // Add new row to table at offset
      this.filteredStats.splice(index + 1, 0, newRow);
    }
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString('en-GB', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: '2-digit',
    });
  }

  onSelectDate(date: any) {
    this.filterStats();
  }

  onSelectOperator(operator: any) {
    this.filterStats();
  }

  onSelectReason(reason: any) {
    this.filterStats();
  }

  filterStats() {
    this.filteredStats = deepClone(this.stats);

    const ft = this.filteredStats.map((x) => {
      return {
        created: new Date(x.created).toDateString(),
        dateCheck: new Date(this.selectedDate).toDateString(),
      };
    });

    this.filteredStats = this.filteredStats.filter(
      (x) =>
        (!this.selectedReason || x.disposition == this.selectedReason) &&
        (!this.selectedOperator || x.operatorId === this.selectedOperator) &&
        (!this.selectedDate ||
          new Date(x.created).toDateString() === new Date(this.selectedDate).toDateString()),
    );
  }
}
